$(document).ready(function() {
    let passwordBlockSelector = '.input-password-group';

    $(passwordBlockSelector+" a").on('click', function(event) {
        event.preventDefault();
        let input = $(this).parent().parent().find('input');
        if(input.attr("type") == "text"){
            input.attr('type', 'password');
            return;
        }
        
        if(input.attr("type") == "password"){
            input.attr('type', 'text');
        }
    });
});